import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Dashboard from '../pages/Dashboard';
import Books from '../pages/Books';
import Orders from '../pages/Orders';
import Users from '../pages/Users';
import Profile from '../pages/Profile';
import Marketing from '../pages/Marketing';
import SearchAnalytics from '../pages/SearchAnalytics';
import Whatsapp from '../pages/Whatsapp';
import BotSettings from '../pages/BotSettings';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import ProtectedRoute from '../components/ProtectedRoute';

const AdminRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="books" element={<Books />} />
          <Route path="orders" element={<Orders />} />
          <Route path="whatsapp" element={<Whatsapp />} />
          <Route path="whatsapp/settings" element={<BotSettings />} />
          <Route path="users" element={<Users />} />
          <Route path="marketing" element={<Marketing />} />
          <Route path="recherches" element={<SearchAnalytics />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AdminRoutes;
